import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageHeader = (props: any) => {
  const { navPath, title } = props;
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const backClickHandler = () => {
    navigate(navPath);
  };
  return (
    <Box
      sx={{
        borderBottom: "1px solid #E2E2E2;",
        minHeight: isMobile ? "55px" : "70px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingLeft: "25px",
        gap: "10px",
      }}
    >
      <img
        onClick={backClickHandler}
        src={require("assets/img/png/backarrow.png")}
        style={{ height: "24px", width: "24px", cursor: "pointer" }}
        alt=""
      />
      <Typography
        sx={{
          fontSize: isMobile ? "18px" : "26px",
          lineHeight: "31px",
          fontWeight: 600,
          fontFamily: "Inter",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default PageHeader;
